//libs
import { styled } from '@nykaa/ui-components';

//components
import Product from 'shared/layouts/Listing/components/ProductPlaceholder';

//constants
import { GUTTER_SPACE } from 'shared/components/ViewSimilar/Desktop/components/ViewSimilarOverlay/constants';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Skeleton = styled(FlexColumn)`
  margin: 0 ${({ theme }) => theme.spacing.spacing40};
`;

export const ProductsArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ProductPlaceholder = styled(Product)`
  width: calc(50% - ${GUTTER_SPACE}px);
  margin-bottom: ${({ theme }) => theme.spacing.spacing200};
`;
